module.exports = __webpack_public_path__ + "static/media/item_2_8.48ffaaaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_8.png
// module id = 115
// module chunks = 0